import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";
import { isMobilePhone } from "validator";

import { SetAdvisor } from "data/advisor/actions";
import { EditAdvisor } from "data/libs/advisor";

import { useBooleanState } from "hooks";

const profileSchema = yup.object({
  firstName: yup.string().trim().required("First Name is required"),
  lastName: yup.string().trim().required("Last Name is required"),
  phoneNumber: yup
    .string()
    .required("Phone Number is required")
    .test((value, ctx) => {
      return (
        isMobilePhone(value) ||
        ctx.createError({ message: "Phone Number is invalid" })
      );
    }),
  firmName: yup
    .string()
    .trim()
    .min(3, "Firm Name must be at least 3 characters long")
    .required("Firm Name is required"),
});

export function useProfileInfoStepForm(
  user,
  onDone = () => {},
  onError = () => {}
) {
  const [isLoading, setLoading, stopLoading] = useBooleanState();
  const [errorMessage, setError] = useState("");
  const dispatch = useDispatch();

  const userPractices = user?.practices || [];
  const initialValues = {
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    phoneNumber: user?.phoneNumber || "",
    firmName: userPractices[0]?.name || "",
  };
  const formProps = useForm({
    resolver: yupResolver(profileSchema),
    mode: "onSubmit",
    defaultValues: initialValues,
    criteriaMode: "all",
  });

  const onSubmit = (updatedFields) => {
    setError("");
    formProps.clearErrors();
    setLoading();

    EditAdvisor(user.id, { ...updatedFields })
      .then((newUser) => {
        dispatch(SetAdvisor(newUser));
        onDone(newUser);
      })
      .catch((error) => {
        setError(error?.message);
        onError(error);
      })
      .finally(() => {
        stopLoading();
      });
  };

  return {
    formProps: formProps,
    loading: isLoading,
    errorMessage: errorMessage,
    onSubmit: onSubmit,
  };
}

export default useProfileInfoStepForm;
